import styled from 'styled-components';

const CookiePolicyText = styled.div`
  color: #000000;
  font-family: 'Avenir', 'Arial', sans-serif;
  font-size: 13px;
  font-weight: 300;
  line-height: 18px;
  display: inline-block;
  text-align: left;
  ${({ isDesktop }) => (isDesktop ? 'margin-right: 26px;' : 'margin: 0 17px;')}
`;

export default CookiePolicyText;
